'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMonochromePhotos = function MdMonochromePhotos(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 31.6v-20h-13.4v1.8c4.7 0 8.4 3.6 8.4 8.2s-3.7 8.4-8.4 8.4v-3c-3 0-5.3-2.4-5.3-5.4s2.3-5.3 5.3-5.3v10.7c3 0 5.3-2.4 5.3-5.4s-2.3-5.3-5.3-5.3v-2.9c-4.7 0-8.4 3.6-8.4 8.2s3.7 8.4 8.4 8.4v1.6h13.4z m0-23.2c1.8 0 3.2 1.4 3.2 3.2v20c0 1.8-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.6-3.2-3.4v-20c0-1.8 1.4-3.2 3.2-3.2h5.4l3-3.4h10l3 3.4h5.4z' })
        )
    );
};

exports.default = MdMonochromePhotos;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/monochrome-photos.js
// module id = 3077
// module chunks = 0